import { Objective } from "@models/objective.model";
import { BaseSerializer } from "./baseSerializer";

export class ObjectiveSerializer extends BaseSerializer {
    public deserialize(data: any): any {
        const objective = new Objective();
        this._copyAttributes(objective, data);
        objective.population_segment_id = data.population_segment?.id
        return objective;
    }
}